<div class="modal-header">
    <h3 class="modal-title" id="modal-title">{{'KUNDORDER_DETAIL_FORSORJNINGSRAD_ADD'|translate}}</h3>
    <button type="button" id="buttonLrClose" class="btn-close" aria-describedby="skapa försörjningsrad" (click)="dismiss()"></button>
</div>

<div class="modal-body">
    <form [formGroup]="form">
        <rask-selector
            class="col-lg-8"
            label="{{'LEVERANTORSORDER_DETAIL_FORSORJNINGSKALLA' | translate}}"
            aid="mottagningsplats"
            formControlName="mottagningsplats"
            [debounceTime]="300" [minCharacters]="3" [placeholder]="'DEFAULT_TYPE_AHEAD_HELP_TEXT' | translate"
            [search]="searchForsorjningskalla"
            [viewFormatter]="forsorjningskallaFormatter"
            [viewSelectedFormatter]="selectedFormatter">
        </rask-selector>
        <rask-input-number
            class="col-lg-4"
            [unit]="leverantorsorderrad.mattslag"
            [label]="'KUNDORDER_DETAIL_FORDELNINGSANDEL' | translate"
            formControlName="totalKvantitet"
            aid="inputTotalKvantitet">
        </rask-input-number>
    </form>
</div>

<div class="modal-footer">
    <rask-button aid="buttonCreate" color="primary" (click)="create()">
        {{'DEFAULT_BUTTON_LABEL_LAGG_TILL'|translate}}
    </rask-button>
</div>
